// extracted by mini-css-extract-plugin
export default {"revokeIcon":"HfMDtkrZBCbqH2VDK7Aw","modalText":"p3SgbKSCt5S_hXoc9Swb","revocationError":"y4iuqA8xJNLa18XGLHNU"};